import React, { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaEye, FaPlus } from "react-icons/fa";
import styles from "../academicConfiguration/Academiclist.module.css";
import { CustomButton } from "../../../../components";
import CustomMRTTable from "../../../../components/CustomMRTTable/CustomMRTTable";
import AxiosInstance from "../../../../services/Api";
import { useSelector } from "react-redux";

const GroupList = () => {
  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [searchInput, setSearchInput] = useState("");
  const [apiSearch, setApiSearch] = useState("");
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const { translations } = useSelector((state) => state.language);
  /* ===========================
     FETCH GROUP LIST
     =========================== */
  useEffect(() => {
    fetchGroupList();
  }, [pagination.pageIndex, pagination.pageSize, apiSearch]);

  const fetchGroupList = async () => {
    setLoading(true);
    try {
      const response = await AxiosInstance.post("/school/listGroup", {
        page: pagination.pageIndex + 1,
        limit: pagination.pageSize,
        search: apiSearch,
      });

      if (response?.data?.rows) {
        setData(response.data.rows || []);
        setRowCount(response.data.total || 0);
      } else {
        setData([]);
        setRowCount(0);
      }
    } catch (error) {
      console.error("Error fetching group list", error);
      setData([]);
      setRowCount(0);
    } finally {
      setLoading(false);
    }
  };

  /* ===========================
     HANDLERS
     =========================== */
  const handleAdd = () => {
    navigate("/user/GroupCreate"); // Navigate to create page
  };

  const handleView = (row) => {
    navigate("/user/GroupCreate", {
      state: {
        id: row.id, // send group id
      },
    });
  };

  /* ===========================
     TABLE COLUMNS (GROUP ONLY)
     =========================== */
  const columns = useMemo(
    () => [
      {
        id: "sno",
        header: translations.labels.serialNo,
        Cell: ({ row, table }) =>
          row.index + 1 + pagination.pageIndex * pagination.pageSize,
        enableSorting: false,
      },
      {
        accessorKey: "name",
        header: translations.labels.groupName,
        enableSorting: true,
      },
      {
        accessorKey: "subject_names",
        header: translations.labels.subject,
        enableSorting: false,
      },
      {
        id: "actions",
        header: translations.labels.actions,
        enableSorting: false,
        Cell: ({ row }) => (
          <button
            className={styles.viewBtn}
            onClick={() => handleView(row.original)}
            title="View/Edit"
          >
            <FaEye />
          </button>
        ),
      },
    ],
    [pagination.pageIndex, pagination.pageSize],
  );

  return (
    <div className={styles.container}>
      {/* HEADER */}
      <div className={styles.header}>
        <h1 className={styles.headerTitle}>{translations.labels.groupList}</h1>
      </div>

      {/* ADD BUTTON */}
      <div className={styles.actions}>
        <CustomButton
          type="button"
          variant="contained"
          className={styles.addButton}
          fullWidth={false}
          onClick={handleAdd}
        >
           <FaPlus style={{ marginRight: "8px" }} />
          {translations.labels.add}
        </CustomButton>
      </div>

      {/* TABLE */}
      <CustomMRTTable
        columns={columns}
        data={data}
        loading={loading}
        pagination={pagination}
        rowCount={rowCount}
        onPaginationChange={setPagination}
        searchInput={searchInput}
        setSearchInput={setSearchInput}
        onSearchEnter={(value) => {
          setApiSearch(value);
          setPagination((prev) => ({ ...prev, pageIndex: 0 }));
        }}
        enableSearch={false}
        enableFiltering={false}
      />
    </div>
  );
};

export default GroupList;
